let session = null
let shopIframe = null
let paymentsEnabled = false
let invalidAccessError = false
let initialized = false
let initializing = false

export function handleApplePayEvent(event) {
  switch (event.data.event) {
    case "init":
      if (initialized) {
        return sendPostMessage(
          "init",
          {
            canMakePayments: paymentsEnabled,
            invalidAccessError: invalidAccessError
          },
          event.source
        )
      }
      if (initializing) {
        if (initialized) {
          return sendPostMessage(
            "init",
            {
              canMakePayments: paymentsEnabled,
              invalidAccessError: invalidAccessError
            },
            event.source
          )
        } else {
          let interval = setInterval(() => {
            if (initialized) {
              clearInterval(interval)
              return sendPostMessage(
                "init",
                {
                  canMakePayments: paymentsEnabled,
                  invalidAccessError: invalidAccessError
                },
                event.source
              )
            }
          }, 500)
          return
        }
      }
      initializing = true
      shopIframe = event.source
      window.ApplePaySession.canMakePaymentsWithActiveCard(
        event.data.data.merchantIdentifier
      )
        .then((canMakePayments) => {
          if (canMakePayments) {
            sendPostMessage("init", { canMakePayments: true }, event.source)
            paymentsEnabled = true
            initialized = true
            initializing = false
          } else {
            // Check for the existence of the openPaymentSetup method.
            if (window.ApplePaySession.openPaymentSetup) {
              sendPostMessage(
                "init",
                {
                  canMakePayments: true,
                  displaySetupButton: true
                },
                event.source
              )
              paymentsEnabled = true
              initialized = true
              initializing = false
            }
          }
        })
        .catch((e) => {
          if (e.name === "InvalidAccessError") {
            sendPostMessage("init", { invalidAccessError: true }, event.source)
            invalidAccessError = true
            initialized = true
            initializing = false
          } else {
            console.error(
              "Error checking for Apple Pay support on root domain! ",
              e
            )
          }
        })
      break
    case "onClick":
      shopIframe = event.source
      onClick(event)
      break
    case "onShippingContactSelected":
      shopIframe = event.source
      session.completeShippingContactSelection(event.data.data)
      break
    case "onShippingMethodSelected":
      shopIframe = event.source
      session.completeShippingMethodSelection(event.data.data)
      break
    case "onPaymentAuthorized":
      shopIframe = event.source
      session.completePayment(event.data.data)
      break
    case "abort":
      session.abort()
      break
  }
}

function sendPostMessage(event, data, source = null) {
  if (event === "init") {
    data.parentDomain = window.location.host
  }
  getSourceIframe(source).contentWindow.postMessage(
    {
      type: "KatalysApplePayEvent",
      event: event,
      data: data
    },
    "*"
  )
}

function onClick(event) {
  session = new window.ApplePaySession(3, event.data.data.request)
  session.onvalidatemerchant = onValidateMerchant
  session.onpaymentauthorized = paymentAuthorized
  session.oncancel = cancel
  session.onshippingmethodselected = shippingMethodSelected
  session.onshippingcontactselected = shippingContactSelected
  // this.session.onpaymentmethodselected = this.onPaymentMethodSelected
  session.begin()
}

async function onValidateMerchant(event) {
  const newSession = await validateMerchant({
    validationURL: event.validationURL,
    displayName: "test name",
    domain: window.location.hostname
  })
  session.completeMerchantValidation(newSession)
}

function paymentAuthorized(event) {
  sendPostMessage("paymentAuthorized", { payment: event.payment })
}

function shippingMethodSelected(event) {
  sendPostMessage("shippingMethodSelected", {
    shippingMethod: event.shippingMethod
  })
}

function shippingContactSelected(event) {
  sendPostMessage("shippingContactSelected", {
    shippingContact: event.shippingContact
  })
}

function cancel() {
  sendPostMessage("cancel", {})
}

function getSourceIframe(source) {
  var iframes = document.getElementsByTagName("iframe")
  for (var i = 0, iframe, win; i < iframes.length; i++) {
    iframe = iframes[i]

    // Cross-browser way to get iframe's window object
    win = iframe.contentWindow || iframe.contentDocument.defaultView

    // Comparison
    if (win === (source || shopIframe)) {
      return iframe
    }
  }
}

async function validateMerchant(data) {
  const options = {
    method: "POST",
    headers: {
      "content-type": "application/json; charset=utf-8"
    },
    body: JSON.stringify(data)
  }
  const response = await fetch(
    window.OneO.shopEnv.publicApiBase + "/apple-pay/",
    options
  )
  if (response.ok) {
    return response.json()
  } else {
    throw new Error("Failed to validate merchant")
  }
}
